import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarDepartamentosCompraDashboard = async (params) => {
  let url = `/departamentos/compras`;

  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamentos;
  }

  logout();
}

export const buscarDepartamentosCompra = async (params) => {
  let url = `/departamentos/${params.iddepartamento}/compras`;

  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamentos;
  }

  logout();
}

export const buscarQtdCategoriasEmGatilhoDeCompra = async (id_grupo, id_filial, id_departamento) => {
  return await ajudanteBuscarTotalCategorias(id_grupo, id_filial, id_departamento, "categorias-em-gatilho-de-compra");
}

export const buscarQtdCategoriasEmCompletarCompra = async (id_grupo, id_filial, id_departamento) => {
  return await ajudanteBuscarTotalCategorias(id_grupo, id_filial, id_departamento, "categorias-em-completar-compra");
}

export const buscarQtdGeralDeCategorias = async (id_grupo, id_filial, id_departamento) => {
  return await ajudanteBuscarTotalCategorias(id_grupo, id_filial, id_departamento, "categorias");
}

export const buscarQtdCategoriasEmTransito = async (id_grupo, id_filial, id_departamento) => {
  return await ajudanteBuscarTotalCategorias(id_grupo, id_filial, id_departamento, "categorias-em-transito");
}

const ajudanteBuscarTotalCategorias = async (id_grupo, id_filial, id_departamento, uri) => {
  const url = `/departamentos/${id_departamento}/compras/grupos/${id_grupo}/filiais/${id_filial}/quantidades/${uri}`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return parseInt(data.qtd_categorias);
  }

  logout();
}

export const find = async (id) => {
  const config = {
    params: { id },
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get('departamentos', config).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamento;
  }

  logout();
}

export const buscarDepartamentosEmGatilhoCompra = async (grupo) => {
  const config = {
    params: { grupo },
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get('/departamentos/em-gatilho-compra', config).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.departamentos;
  }

  logout();
}

export const buscarConfiguracoesDepartamento = async (id_departamento) => {
  const params = {id_departamento};
  const {data, status} = await api.get(`/departamentos/configuracao`, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.config;
  }

  logout();
}

export const salvarConfiguracoesDepartamento = async (requisicao) => {
  const {data, status} = await api.post('/departamentos/configuracao', requisicao, {headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarUltimasVendasMensais = async (params) => {
  const config = { params, headers: iniciarRequisicao() };
  const {data, status} = await api.get('/departamentos/vendas-mensal', config).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.vendas;
  }

  logout();
}
